"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_DIFFERENT_EPA_SUPERVISOR_EMAIL = exports.UPDATE_MY_TUITION_PROVIDER_EMAIL_NOTIFICATION = exports.SEND_STUDENT_ULN_UPDATES_NOTIFICATION = exports.SEND_TUITION_PROVIDER_EPA2_SUBMISSION_NOTIF = exports.SEND_NEW_SUPERVISOR_EMAIL_NOTIF = exports.SEND_STUDENT_RECEIVE_NOTIFICATION = exports.CREATE_ATTESTATIONS = exports.CREATE_ATTESTATION = exports.GET_EPA2L7_SUBMISSIONS = exports.GET_EPA2_SUBMISSIONS = exports.CANCEL_ALL_SEAT_INVITE = exports.CANCEL_SEAT_INVITE = exports.ACCEPT_FIRM_MEMBERSHIP_INVITE = exports.DELETE_ADDRESS = exports.ADD_ADDRESS = exports.SEARCH_INDIVIDUAL = exports.CREATE_NEW_LEAD = exports.SUBMIT_ENQUIRY_FORM = exports.individualResult = void 0;
exports.individualResult = `{
  Id
  Title
  Name
  FirstName
  LastName
  SFS_IND_Email__c
  PersonMailingAddress
  SFS_PAC_AreaExpertise__c
  SFS_PAC_EthicsStatus__c
  Phone
  SFS_PAC_LinkedInURL__c
  PersonEmail
  OrgName
  MembershipType
  CredentialsHeld
  CPALicense
  TuitionProvider
  designatoryLetters
  awardedDate
  currentLevel
  examsCompleted
  admissionDate
  amlSupervisoryStatus
}`;
exports.SUBMIT_ENQUIRY_FORM = `
	mutation submitEnquiryForm(
    $queryString: String!,
    $type: String!,
  ) {
		submitEnquiryForm(
      queryString: $queryString,
      type: $type,
    ) {
      success
    }
	}
`;
exports.CREATE_NEW_LEAD = `
  mutation createNewLeadExistingIndividual(
    $firstName: String,
    $lastName: String,
    $phone: String,
    $email: String,
    $inquiryRole: String,
    $countryCode: String,
    $state: String,
    $iWorkIn: String,
    $receivedEmail: Boolean,
    $receivedSms: Boolean,
  ) {
    createNewLeadExistingIndividual(
      firstName: $firstName,
      lastName: $lastName,
      phone: $phone,
      email: $email,
      inquiryRole: $inquiryRole,
      countryCode: $countryCode,
      state: $state,
      iWorkIn: $iWorkIn,
      receivedEmail: $receivedEmail,
      receivedSms: $receivedSms,
    ) {
      success
      errorMessage
    }
  }
`;
exports.SEARCH_INDIVIDUAL = `
  query searchIndividual($searchType: Int, $fullName: String, $firstName: String, $lastName: String, $location: LocationItemList, $membershipType: String, $isAdmin: Boolean, $credential: String, $company: String, $expertiseArea: String, $pageNumber: Int, $pageSize: Int, $credentialProductSkuMap: JSON) {
    searchIndividual(searchType: $searchType, fullName: $fullName, firstName: $firstName, lastName: $lastName, location: $location, membershipType: $membershipType, isAdmin: $isAdmin, credential: $credential, company: $company, expertiseArea: $expertiseArea, pageNumber: $pageNumber, pageSize: $pageSize, credentialProductSkuMap: $credentialProductSkuMap) {
      individualResults ${exports.individualResult},
      totalSize
    }
  }
`;
exports.ADD_ADDRESS = `
  mutation addAddress($address: AddressBookItem) {
    addAddress(address: $address)
  }
`;
exports.DELETE_ADDRESS = `
  mutation deleteAddress($id: String!) {
    deleteAddress(id: $id)
  }
`;
exports.ACCEPT_FIRM_MEMBERSHIP_INVITE = `
  mutation acceptFirmMembershipInvite($inviteId: String!, $applicationId: String, $customerPayingSku: String) {
    acceptFirmMembershipInvite(inviteId: $inviteId, applicationId: $applicationId, customerPayingSku: $customerPayingSku) {
        success
        isPaidByFirm
        isUpgradeMembership
    }
  }
`;
exports.CANCEL_SEAT_INVITE = `
  mutation cancelSeatInvite($inviteId: String!) {
    cancelSeatInvite(inviteId: $inviteId) {
        success
    }
  }
`;
exports.CANCEL_ALL_SEAT_INVITE = `
  mutation cancelAllSeatInvite($inviteIdList: [String]) {
    cancelAllSeatInvite(inviteIdList: $inviteIdList) {
        success
    }
  }
`;
exports.GET_EPA2_SUBMISSIONS = `
  query {
    getEPA2Submissions
  }
`;
exports.GET_EPA2L7_SUBMISSIONS = `
  query {
    getEPA2L7Submissions
  }
`;
exports.CREATE_ATTESTATION = `
  mutation ($attestationText: String) {
    createAttestation(attestationText: $attestationText) {
      success
    }
  }
`;
exports.CREATE_ATTESTATIONS = `
  mutation ($attestations: [CreateAttestation]) {
    createAttestations(attestations: $attestations) {
      success
    }
  }
`;
exports.SEND_STUDENT_RECEIVE_NOTIFICATION = `
  mutation sendStudentReceiveNotification($status: String, $caseId: String, $employerValidator: String) {
    sendStudentReceiveNotification(status: $status, caseId: $caseId, employerValidator: $employerValidator){
      success
    }
  }
`;
exports.SEND_NEW_SUPERVISOR_EMAIL_NOTIF = `
  mutation sendNewSupervisorEmailNotif($studentId: String, $email: String) {
    sendNewSupervisorEmailNotif(studentId: $studentId, email: $email) {
      success
    }
  }
`;
exports.SEND_TUITION_PROVIDER_EPA2_SUBMISSION_NOTIF = `
  mutation ($status: String, $caseId: String) {
    sendTuitionProviderEPA2SubmissionNotif(status: $status, caseId: $caseId) {
      success
    }
  }
`;
exports.SEND_STUDENT_ULN_UPDATES_NOTIFICATION = `
  mutation sendStudentULNUpdatesNotification($updatedULN: String, $previousULN: String, $firstName: String, $email: String, $personContactId: String) {
    sendStudentULNUpdatesNotification(updatedULN: $updatedULN, previousULN: $previousULN, firstName: $firstName, email: $email, personContactId: $personContactId){
      success
    }
  }
`;
exports.UPDATE_MY_TUITION_PROVIDER_EMAIL_NOTIFICATION = `
  mutation sendEmailNotifProfileTuitionProviderUpdateDetails($customerName: String, $transactionName: String, $email: String, $personContactId: String, $tpName: String) {
    sendEmailNotifProfileTuitionProviderUpdateDetails(customerName: $customerName, transactionName: $transactionName, email: $email, personContactId: $personContactId, tpName: $tpName){
      success
    }
  }
`;
exports.SEND_DIFFERENT_EPA_SUPERVISOR_EMAIL = `
  mutation sendDifferentEpaSupervisor($caseId: String, $emailAddress: String, $supervisorFirstName: String, $supervisorLastName: String, $apprenticeULN: String, $apprenticeEmployerName: String) {
    sendDifferentEpaSupervisor(caseId: $caseId, emailAddress: $emailAddress, supervisorFirstName: $supervisorFirstName, supervisorLastName: $supervisorLastName, apprenticeULN: $apprenticeULN, apprenticeEmployerName: $apprenticeEmployerName){
      success
    }
  }
`;
//# sourceMappingURL=customer-queries.js.map